// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-item[data-v-abf864cc]:not(:first-child){margin-left:-20px;z-index:1}.user-card-wrapper[data-v-abf864cc]{padding:10px}.user-wrapper[data-v-abf864cc]{white-space:nowrap;overflow:hidden}.user-email[data-v-abf864cc]{color:silver}.no-user-name[data-v-abf864cc]{color:silver;font-style:italic}.action-items[data-v-abf864cc]{width:15px;height:15px;position:absolute;right:10px;cursor:pointer;fill:silver;z-index:1}", ""]);
// Exports
module.exports = exports;
